import ApplicationSerializer from '@square/dashboard-data/serializers/application';
export default ApplicationSerializer.extend({
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    return this._super(store, primaryModelClass, payload.entities, id, requestType);
  }
});